import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useStartSingleClaim = () => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {apiClient, uuid, setClaimId} = useContext(OrderContext);


  const startClaim = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(`api/v1/refund/${uuid}/start_single_claim/`, {
        type : id
      });
      const data = response.data;
      setClaimId(data.Id)
     
    } catch (error) {
      const msg = error.response?.data?.error || error.message || 'API error';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return {startClaim};
};

export default useStartSingleClaim;
